import React from "react";
import { Skeleton } from "../../Skeleton/Skeleton";

export const BadgeSkeleton = ({ size, shape }) => {
    const _size = size === "xs" ? 20 : 24;
    const rounded = shape === "round" ? "full" : "sm";
    return <Skeleton width={_size} height={_size} rounded={rounded} />
}